module.exports = __webpack_public_path__ + "img/empty-state-percent.556c5679.svg";